// Per-brand homepage data, ported from Homepage.master(.vb):
// BrandSentenceActivity, GetBrandDefaults(), and the three feature blocks.
// Receives the merged configuration globals (for brand) plus url parameters.
export default (parameters) => {
  const { brand, requestedCoverPhoto } = parameters
  const brandLower = (brand || '').toLowerCase()

  // Legacy CoverPhotosManager.GetBrandDefaults(), verbatim
  const defaultCovers = {
    fishweather: {
      top_photo: 'https://cdn-consumer.weatherflow.com/brand-images/fw/FW_TOP.webp',
      top_position: 'center',
      mid_photo: 'https://www.fishweather.com/App_Themes/FishWeather/images/images/top-cover.webp',
      mid_position: 'center',
      brand_class: '',
      logo_color: 'white',
      tagline_color: 'white'
    },
    sailflow: {
      top_photo: 'https://cdn-consumer.weatherflow.com/brand-images/sf/SF_TOP.webp',
      top_position: 'center',
      mid_photo: 'https://www.sailflow.com/App_Themes/SailFlow/images/images/middle-cover.webp',
      mid_position: 'center',
      brand_class: '',
      logo_color: 'white',
      tagline_color: 'white'
    },
    ikitesurf: {
      top_photo: 'https://cdn-consumer.weatherflow.com/brand-images/ik/CORE_1.webp',
      top_position: 'center',
      mid_photo: 'https://cdn-consumer.weatherflow.com/brand-images/ik/CORE_2.webp',
      mid_position: 'bottom',
      brand_class: 'core',
      logo_color: 'white',
      tagline_color: 'black'
    },
    iwindsurf: {
      top_photo: 'https://cdn-consumer.weatherflow.com/brand-images/iw/SAILWORKS_1.webp',
      top_position: 'center',
      mid_photo: 'https://cdn-consumer.weatherflow.com/brand-images/iw/SAILWORKS_2.webp',
      mid_position: 'top',
      brand_class: 'sailworks',
      logo_color: 'white',
      tagline_color: 'white'
    },
    windalert: {
      top_photo: 'https://www.windalert.com/App_Themes/WindAlert/images/images/top-cover.webp',
      top_position: 'center',
      mid_photo: 'https://www.windalert.com/App_Themes/WindAlert/images/images/middle-cover.webp',
      mid_position: 'center',
      brand_class: '',
      logo_color: 'white',
      tagline_color: 'white'
    }
  }

  // Legacy BrandSentenceActivity
  const sentenceActivities = {
    fishweather: 'Fish',
    ikitesurf: 'Ride',
    sailflow: 'Sail',
    iwindsurf: 'Sail'
  }

  // Legacy: only iKitesurf/iWindsurf pull rotating photos from the sheet API
  const coverPhotoBrandKeys = { ikitesurf: 'ik', iwindsurf: 'iw' }

  // Legacy feature 3 copy prints "Sailflow" (not "SailFlow") — preserved
  const liveWindBrandNames = {
    ikitesurf: 'iKitesurf',
    sailflow: 'Sailflow',
    iwindsurf: 'iWindsurf',
    fishweather: 'FishWeather',
    windalert: 'WindAlert'
  }

  const sentenceActivity = sentenceActivities[brandLower] || 'Are'
  const spotNoun = ['ikitesurf', 'iwindsurf'].includes(brandLower) ? 'spots' : 'locations'
  const liveWindBrandName = liveWindBrandNames[brandLower] || ''

  return {
    sentence_activity: sentenceActivity,
    spot_noun: spotNoun,
    cover_photo_brand_key: coverPhotoBrandKeys[brandLower] || null,
    live_wind_brand_name: liveWindBrandName,
    requested_cover_photo: requestedCoverPhoto || null,
    requested_feature_id: parameters.requestedFeatureId || null,
    default_cover: defaultCovers[brandLower] || defaultCovers.windalert,
    // Feature images are bundled JWX assets, mapped by id in HomeFeature.vue
    features: [
      {
        id: 1,
        heading: `Weather Stations Where You ${sentenceActivity}.`,
        body: 'Over 50,000 Weather Stations worldwide, including our exclusive PRO Stations: built ultra heavy-duty by our own MIT engineer, and sited by our meteorologists for the highest possible quality of wind reports.',
        alt: 'Weather Stations'
      },
      {
        id: 2,
        heading: `Weather Forecasts Where You ${sentenceActivity}.`,
        body: `Multiple Forecasts for all ${spotNoun} worldwide! And- Since 1987, our staff meteorologist-written PRO Forecast discussions are the gold standard: simply the finest in-depth Wind Forecasts available ANYWHERE.`,
        alt: 'Weather Forecasts'
      },
      {
        id: 3,
        heading: `LIVE WIND Where You ${sentenceActivity}.`,
        body: `${liveWindBrandName} LIVE WIND gives you an insanely addicting view of the wind! A truly next level feature, LIVE WIND = our Flow Map forecast + the latest reports from our real-time Weather Stations.`,
        alt: 'Live Wind'
      }
    ]
  }
}
